/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import GlobalSettings from '@/model/global/GlobalSettings'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'
import Dish from '@/model/dataLayer/api/dish/Dish'
import { findABuffetPriceCategoryOrMakeOne } from '@/model/dataLayer/api/buffet/buffetApis'

const entity = {
  dishesId: {
    // displayName: 'name',
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'product_info', // 产品信息
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false
  },
  code: {
    tableConfig: {
      width: '160'
    },
    formConfig: {
      unique: true,
      uniqueTrackingList: Dish.getList
    }
  },
  price: {
    type: IKDataEntity.Types.Float
  },
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      disableEdit: true,
      type: {
        selectItems: ConsumeType.getList,
        itemText: 'name'
      }
    },
    form: false
  },
  isForAdult: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    } // displayName: 'Für Erwachsene',
  }
}

const config = {

  load: async function (filter) {
    return ((await hillo.get('ConsumeType.php?op=showBuffetPriceDishToConsumeTypeByConsumeType',
      Object.assign({ lang: GlobalSettings.getLang() }, ...filter))).content).map(d => {
      d.id = d.dishesId
      d.langs.map(it => {
        it.desc = it.description
        return it
      })
      return d
    })
  },
  add: async function (item) {
    item.printGroupId = 10
    item.categoryId = (await findABuffetPriceCategoryOrMakeOne()).id
    const res = (await Dish.add(item))
    item.dishId = res.id
    item.isForAdult = item.isForAdult ? 1 : 0
    return hillo.postWithUploadFile('ConsumeType.php?op=setBuffetPriceDishToConsumeType', item, {
      showLoading: false
    })
  },
  edit: async function (item) {
    item.printGroupId = 10
    item.categoryId = (await findABuffetPriceCategoryOrMakeOne()).id
    item.isActive = 1
    item.dishId = item.dishesId
    item.isForAdult = item.isForAdult ? 1 : 0
    await Dish.edit(item)
    return hillo.postWithUploadFile('ConsumeType.php?op=setBuffetPriceDishToConsumeType', item, {
      showLoading: false
    })
  },
  remove: async function (id) {
    const uploadRemoveItem = { dishId: id }
    await hillo.post('ConsumeType.php?op=deleteBuffetPriceDishToConsumeType', uploadRemoveItem, { showLoading: false })
    return await Dish.remove(id)
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function bindDishesByBuffetPrice (dish, consumeTypeId) {
  dish.consumeTypeId = consumeTypeId
  return hillo.post('ConsumeType.php?op=setBuffetPriceDishToConsumeType', {
    ...dish
  }, {
    showLoading: false
  })
}
